export const PROJECT_AREA_LIMIT = 5000;

// PSCO-92: gates the Program Manager / Sub-Program Manager fields on both the create and edit
// project forms. Shared by NewProjectDetails.tsx and pages/projectDetails/details/index.tsx.
export const PROGRAM_MANAGER_FLAG = 'project-enable-program-manager';

export const placeholderAndTooltips = {
  costTooltip:
    'Project costs are automatically calculated based on the size of your project. This base cost captures the full CivilGrid, CivilSearch, and CivilDraw experience for your project. Other offerings are priced as a percentage of this base cost and are shown on the next screen. Add-ons (e.g., zoning) and paid reports (e.g., title reports) are priced in their respective sections after project creation.',

  projectNameTooltip:
    'Use a descriptive name for your project. If you request maps and as-builts through CivilSearch, CivilGrid will use this name to refer to the project in any communications with external agencies performed on your behalf.',

  pmTooltip:
    'The PM will receive notifications from CivilGrid of Project activity and invoices. They manage the team who can access this Project.',

  programManagerTooltip:
    'Optional. The Program Manager oversees this project at a broader level and will receive notifications from CivilGrid when assigned.',

  subProgramManagerTooltip:
    'Optional. The Sub-Program Manager supports the Program Manager on this project and will receive notifications from CivilGrid when assigned.',

  billingCodeTooltip:
    'The Billing Code will appear in your invoices from CivilGrid for this Project. Use this field for your internal accounting. Examples: project number, billing code, phase/task.',
  billingCodePlaceholder: 'JOB-123',

  scopePlaceholder:
    'Acme Engineers is contracted to Local Water Utility for engineering design services on their New Pipeline Project. Acme will perform preliminary site research, create potholing plans, develop utility avoidance plans, and develop initial pipeline alignments.',
  scopeTooltip:
    'Write a brief description of your project scope. If you are a public agency, or are working for a public agency client, please mention the agency. If there are public links or articles about the project, please share those as well.',

  addressTooltip:
    'If you request maps and as-builts through CivilSearch, CivilGrid will share this address to refer to the project in any communications with external agencies performed on your behalf.',

  projectVicinityTooltip:
    'Describe your project area, including approximate dimensions where relevant. If the project consists of multiple segments, describe each segment. CivilGrid will include a vicinity map of the project boundaries when requesting concurrence from data partners.',
  projectVicinityPlaceholder: `5-mile span along 5th Boulevard from A St. to H St. in Anytown, CA.

33-acre area around Anytown High School immediately south of downtown.`,

  projectNarrativeTooltip: (
    <div className="flex flex-col space-y-2">
      <div>
        CivilGrid works directly with utility data partners in order to bring you live utility data on the platform and
        available via download to CAD or GIS. For security reasons, our partners have area restrictions for certain data
        types which we enforce for self-serve downloads.
      </div>
      <div>
        Please fill out this form describing your project scope, vicinity, and data usage. This project narrative will
        be communicated to data partners in order to request concurrence on downloads exceeding these restrictions.
      </div>
      <div>
        We will send a composite file in the requested format with all utilities available for download for the entire
        project area when all concurrences are received. It make take several days for CivilGrid to receive concurrence
        from all the partners.
      </div>
      <div>Please email support@civilgrid.com for any questions.</div>
    </div>
  ),
};
